import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = ["textContent"]

export type AppNavigationItem = {
  title: string
  route?: { name: string, params?: Record<string, string> },
  href?: string,
  level?: number,
  children?: AppNavigationItem[]
  flag?: {
    text: string,
    color: string
  }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppNavigationItem',
  props: {
    title: {},
    route: {},
    href: {},
    level: { default: 0 },
    children: {},
    flag: {}
  },
  setup(__props: any) {




const currentPath = computed(() => useRoute().fullPath)
const isGroup = computed(
  () => __props.children && __props.children.length > 0
)
const isActive = computed(() => {
  if (!__props.route) return false

  // Special handling for home link
  if (__props.route.name === 'home') {
    return currentPath.value === '/'
  }

  // True if the current page's URL starts with our item URL
  const resolvedPath = useRouter().resolve({ name: __props.route.name, params: __props.route.params }).href
  return currentPath.value.startsWith(resolvedPath)
});


return (_ctx: any,_cache: any) => {
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_AppNavigationItem = _resolveComponent("AppNavigationItem", true)!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_unref(isGroup))
    ? (_openBlock(), _createBlock(_component_v_list_group, {
        key: 0,
        color: "primary"
      }, {
        activator: _withCtx(({ props: vProps }) => [
          _createVNode(_component_v_list_item, _mergeProps({ color: "#FFFFFF88" }, vProps, {
            rounded: "0",
            class: "app-navigation-item pa-1"
          }), {
            prepend: _withCtx(() => [
              _createVNode(_component_hy_icon, {
                name: __props.title,
                class: "nav-icon mr-3"
              }, null, 8, ["name"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "title",
                textContent: _toDisplayString(__props.title)
              }, null, 8, _hoisted_1)
            ]),
            _: 1
          }, 16)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.children, (child) => {
            return (_openBlock(), _createBlock(_component_AppNavigationItem, _mergeProps({
              key: child.title
            }, { ref_for: true }, child, {
              level: __props.level + 1
            }), null, 16, ["level"]))
          }), 128))
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_list_item, {
        key: 1,
        to: __props.route,
        href: __props.href,
        target: __props.href ? '_blank' : undefined,
        active: _unref(isActive),
        rounded: "0",
        class: "app-navigation-item pa-1"
      }, {
        prepend: _withCtx(() => [
          _createVNode(_component_hy_icon, {
            name: __props.title,
            class: "nav-icon mr-3"
          }, null, 8, ["name"])
        ]),
        append: _withCtx(() => [
          (__props.flag)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                size: "x-small",
                variant: "flat",
                color: __props.flag.color
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.flag.text), 1)
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "title",
            textContent: _toDisplayString(__props.title)
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["to", "href", "target", "active"]))
}
}

})